import React from "react";
import { makeStyles } from "@material-ui/core";
import { Package } from "lucide-react";

const useStyles = makeStyles((theme) => ({
  bundle: {
    padding: "16px",
    background: "rgba(234, 179, 8, 0.1)",
    borderRadius: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    border: "1px solid #e5e7eb",
    color: "#21242c",
    marginTop: "16px",
  },
  bundleHeader: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    margin: 0,
  },
  title: {
    fontSize: "16px",
    color: "#21242c",
    fontWeight: 600,
  },
  subtitle: {
    fontSize: "14px",
    color: "#676f7e",
  },
  bundleFooter: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "8px",
    marginLeft: 0,
  },
  svg: {
    stroke: "rgba(234, 179, 8, 1)",
    width: "24px",
    height: "24px",
  },
}));

const BundleResume = (props) => {
  const classes = useStyles();
  const { bundle } = props;
  return (
    <li className={classes.bundle}>
      <dt className={classes.bundleHeader}>
        <Package className={classes.svg} />
        <p className={classes.header}>
          <span className={classes.title}>{bundle.title}</span>
          {bundle.packageItems
            .filter((el) => el.visibilityForm)
            .map((p) => (
              <span
                className={classes.subtitle}
                key={`${p.id}-${bundle.id}-resume`}
              >
                {p.label}
              </span>
            ))}
        </p>
      </dt>
      <dd className={classes.bundleFooter}>
        <span className={classes.subtitle}>Pacchetto</span>
        <span className={classes.title}>€ {bundle.discountedPrice}</span>
      </dd>
    </li>
  );
};

export default BundleResume;
